import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";

declare var ko: any;

export class discountsView_template extends vnTemplate {

    protected getTemplateHtml(): string {
        return /*html*/`
            <div class="form-header">
                <button data-bind="event: { click: onClickCancel }" class="btn icon i-back" type="button">Go Back</button>
                <h3 class="form-title icon i-discount" data-bind="text: name"></h3>
                <div class="w-btn">
                    <button data-bind="event: { click: onClickEdit }" class="btn icon i-edit" type="button">Edit Discount</button>
                </div>
            </div>

            <!-- Basic Information -->
            <div class="w-form-body">
                <div class="form-body">
                    <strong class="form-sub-title">Basic Information</strong>
                </div>
            </div>

            <div class="w-form-body">
                <div class="form-body">
                    <div class="form-group">
                        <dl class="double-list">
                            <dt><span>ID</span></dt>
                            <dd><span data-bind="text: id"></span></dd>

                            <dt><span>Name / Headline</span></dt>
                            <dd><span data-bind="text: name"></span></dd>

                            <dt><span>Slug</span></dt>
                            <dd class="no-cap"><span data-bind="text: slug"></span></dd>

                            <dt><span>Merchant</span></dt>
                            <dd><span data-bind="text: merchantName"></span></dd>

                            <dt><span>Status</span></dt>
                            <dd>
                                <span class="status-badge" data-bind="text: isActive() ? 'Active' : 'Inactive', css: { 'active': isActive(), 'inactive': !isActive() }"></span>
                            </dd>
                        </dl>
                    </div>
                </div>

                <div class="form-body">
                    <div class="form-group">
                        <dl class="double-list">
                            <dt><span>Short Description</span></dt>
                            <dd class="no-cap"><span data-bind="text: blurb"></span></dd>

                            <dt><span>Full Description</span></dt>
                            <dd class="no-cap"><span data-bind="html: description"></span></dd>

                            <!-- ko if: logoImageUrl() -->
                            <dt><span>Logo</span></dt>
                            <dd>
                                <img data-bind="attr: { src: logoImageUrl }" style="max-width: 200px; max-height: 100px;" />
                            </dd>
                            <!-- /ko -->
                        </dl>
                    </div>
                </div>
            </div>

            <!-- Categories & Availability -->
            <div class="w-form-body">
                <div class="form-body">
                    <strong class="form-sub-title">Categories & Availability</strong>
                </div>
            </div>

            <div class="w-form-body">
                <div class="form-body">
                    <div class="form-group">
                        <dl class="double-list">
                            <dt><span>Categories</span></dt>
                            <dd><span data-bind="text: categoriesDisplay"></span></dd>

                            <dt><span>Available To</span></dt>
                            <dd><span data-bind="text: branchesDisplay"></span></dd>

                            <dt><span>Redemption Location</span></dt>
                            <dd><span data-bind="text: redemptionTypeLabel"></span></dd>
                        </dl>
                    </div>
                </div>

                <div class="form-body">
                    <div class="form-group">
                        <dl class="double-list">
                            <dt><span>Start Date</span></dt>
                            <dd><span data-bind="text: startDateDisplay"></span></dd>

                            <dt><span>End Date</span></dt>
                            <dd><span data-bind="text: endDateDisplay"></span></dd>

                            <!-- ko if: expiredMessage() -->
                            <dt><span>Expired Message</span></dt>
                            <dd class="no-cap"><span data-bind="text: expiredMessage"></span></dd>
                            <!-- /ko -->
                        </dl>
                    </div>
                </div>
            </div>

            <!-- Redemption Details -->
            <div class="w-form-body">
                <div class="form-body">
                    <strong class="form-sub-title">Redemption Details</strong>
                </div>
            </div>

            <div class="w-form-body">
                <div class="form-body">
                    <div class="form-group">
                        <dl class="double-list">
                            <dt><span>Deal Type</span></dt>
                            <dd><span data-bind="text: dealTypeLabel"></span></dd>

                            <!-- ko if: couponCode() -->
                            <dt><span>Coupon Code</span></dt>
                            <dd><code data-bind="text: couponCode"></code></dd>
                            <!-- /ko -->

                            <!-- ko if: redemptionOnlineUrl() -->
                            <dt><span>Business URL</span></dt>
                            <dd class="no-cap">
                                <a data-bind="attr: { href: redemptionOnlineUrl }, text: redemptionOnlineUrl" target="_blank"></a>
                            </dd>
                            <!-- /ko -->

                            <!-- ko if: redemptionOnlineLabel() -->
                            <dt><span>Button Label</span></dt>
                            <dd><span data-bind="text: redemptionOnlineLabel"></span></dd>
                            <!-- /ko -->
                        </dl>
                    </div>
                </div>
            </div>

            <!-- Contact & Advanced -->
            <div class="w-form-body">
                <div class="form-body">
                    <strong class="form-sub-title">Contact & Advanced</strong>
                </div>
            </div>

            <div class="w-form-body">
                <div class="form-body">
                    <div class="form-group">
                        <dl class="double-list">
                            <!-- ko if: contactName() -->
                            <dt><span>Contact Name</span></dt>
                            <dd><span data-bind="text: contactName"></span></dd>
                            <!-- /ko -->

                            <!-- ko if: contactEmail() -->
                            <dt><span>Contact Email</span></dt>
                            <dd class="no-cap">
                                <a data-bind="attr: { href: 'mailto:' + contactEmail() }, text: contactEmail"></a>
                            </dd>
                            <!-- /ko -->

                            <!-- ko if: gamSidebarTrackerUrl() -->
                            <dt><span>GAM Sidebar Tracker URL</span></dt>
                            <dd class="no-cap">
                                <a data-bind="attr: { href: gamSidebarTrackerUrl }, text: gamSidebarTrackerUrl" target="_blank"></a>
                            </dd>
                            <!-- /ko -->

                            <!-- ko if: gamFeaturedTrackerUrl() -->
                            <dt><span>GAM Featured Tracker URL</span></dt>
                            <dd class="no-cap">
                                <a data-bind="attr: { href: gamFeaturedTrackerUrl }, text: gamFeaturedTrackerUrl" target="_blank"></a>
                            </dd>
                            <!-- /ko -->
                        </dl>
                    </div>
                </div>

                <div class="form-body">
                    <div class="form-group">
                        <dl class="double-list">
                            <dt><span>Date Created</span></dt>
                            <dd><span data-bind="text: dateCreated"></span></dd>

                            <dt><span>Date Updated</span></dt>
                            <dd><span data-bind="text: dateUpdated"></span></dd>
                        </dl>
                    </div>
                </div>
            </div>
        `;
    }

    protected initPartial(): void {
        // No child templates needed
    }

    protected getTemplateName(): string {
        return "discountsView_template";
    }

    protected getMainElementType(): string {
        return "div";
    }

    protected getMainElementClasses(): string[] {
        return ["w-form", "w-form-large"];
    }

    protected buildViewModel(): any {
        const self = this;
        return {
            id: ko.observable(""),
            name: ko.observable(""),
            slug: ko.observable(""),
            blurb: ko.observable(""),
            description: ko.observable(""),
            merchantName: ko.observable(""),
            isActive: ko.observable(false),
            logoImageUrl: ko.observable(""),
            categoriesDisplay: ko.observable(""),
            branchesDisplay: ko.observable(""),
            redemptionType: ko.observable(""),
            redemptionTypeLabel: ko.observable(""),
            dealType: ko.observable(""),
            dealTypeLabel: ko.observable(""),
            couponCode: ko.observable(""),
            redemptionOnlineUrl: ko.observable(""),
            redemptionOnlineLabel: ko.observable(""),
            startDateDisplay: ko.observable(""),
            endDateDisplay: ko.observable(""),
            expiredMessage: ko.observable(""),
            contactName: ko.observable(""),
            contactEmail: ko.observable(""),
            gamSidebarTrackerUrl: ko.observable(""),
            gamFeaturedTrackerUrl: ko.observable(""),
            dateCreated: ko.observable(""),
            dateUpdated: ko.observable(""),

            onClickEdit: (data, event) => {
                self.onClickEdit();
            },
            onClickCancel: (data, event) => {
                self.onClickCancel();
            }
        };
    }

    public setDiscountData(discount: any): void {
        const vm = this.getTemplateViewModel();
        
        vm.id(discount.id);
        vm.name(discount.name || '');
        vm.slug(discount.slug || '');
        vm.blurb(discount.blurb || '');
        vm.description(discount.description || '');
        vm.merchantName(discount.merchant ? discount.merchant.name : (discount.merchantName || ''));
        vm.isActive(discount.isActive !== false);
        vm.redemptionType(discount.redemptionType || '');
        vm.redemptionTypeLabel(this.getRedemptionTypeLabel(discount.redemptionType));
        vm.dealType(discount.dealType || '');
        vm.dealTypeLabel(this.getDealTypeLabel(discount.dealType));
        vm.couponCode(discount.couponCode || '');
        vm.redemptionOnlineUrl(discount.redemptionOnlineUrl || '');
        vm.redemptionOnlineLabel(discount.redemptionOnlineLabel || '');
        vm.startDateDisplay(discount.startDate ? discount.startDate.substring(0, 10) : 'No start date');
        vm.endDateDisplay(discount.endDate ? discount.endDate.substring(0, 10) : 'Ongoing');
        vm.expiredMessage(discount.expiredMessage || '');
        vm.contactName(discount.contactName || '');
        vm.contactEmail(discount.contactEmail || '');
        vm.gamSidebarTrackerUrl(discount.gamSidebarTrackerUrl || '');
        vm.gamFeaturedTrackerUrl(discount.gamFeaturedTrackerUrl || '');
        vm.dateCreated(discount.dateCreated ? discount.dateCreated.substring(0, 10) : '');
        vm.dateUpdated(discount.dateUpdated ? discount.dateUpdated.substring(0, 10) : '');

        // Categories display
        if (discount.categories && discount.categories.length > 0) {
            vm.categoriesDisplay(discount.categories.map(c => c.name).join(', '));
        } else {
            vm.categoriesDisplay('None');
        }

        // Branches display
        if (discount.branches && discount.branches.length > 0) {
            vm.branchesDisplay(discount.branches.map(b => b.name).join(', '));
        } else {
            vm.branchesDisplay('All');
        }

        // Image comes from merchant (via discount.image or discount.merchant.image)
        const image = discount.image || (discount.merchant && discount.merchant.image);
        if (image) {
            vm.logoImageUrl(image.url);
        }
    }

    protected getRedemptionTypeLabel(type: string): string {
        switch(type) {
            case 'online': return 'Online Only';
            case 'in-store': return 'In-Store Only';
            case 'both': return 'Online & In-Store';
            default: return type || 'Not specified';
        }
    }

    protected getDealTypeLabel(type: string): string {
        switch(type) {
            case 'link': return 'Link to Website';
            case 'coupon': return 'Coupon Code';
            default: return type || 'Not specified';
        }
    }

    protected onClickEdit(): void {
        const id = this.getTemplateViewModel().id();
        this.caller.onClickEditDiscount(id);
    }

    protected onClickCancel(): void {
        this.caller.onClickCancel();
    }

    public setIdBrand(idBrand: number): void {
        // Store brand ID if needed
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/discountsView_template.ts